declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_left_with_separate_default_and_comment_bar extends $mol_object {
		rows( ): readonly(any)[]
	}
	
	type $mol_view_tree2_to_js_test_ex_left_with_separate_default_and_comment_bar__rows_mol_view_tree2_to_js_test_ex_left_with_separate_default_and_comment_foo_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view_tree2_to_js_test_ex_left_with_separate_default_and_comment_bar['rows'] >
	>
	export class $mol_view_tree2_to_js_test_ex_left_with_separate_default_and_comment_foo extends $mol_object {
		content( ): number
		Obj( ): $mol_view_tree2_to_js_test_ex_left_with_separate_default_and_comment_bar
	}
	
}

//# sourceMappingURL=left_with_separate_default_and_comment.view.tree.d.ts.map